<div *ngxPermissionsOnly="[role.user]">
  <div class="row">
    <div class="col-12 col-lg-9 list-title">
      <app-page-title content="Quotes"></app-page-title>
      <app-quote-list-tabs [active]="activeTab" />
    </div>
    <div class="col-12 col-lg-3">
      <app-search-box
        dataCy="agent-request-search"
        [(value)]="searchQuery"
        (searchSubmit)="onSearchQueryChange()"
      />
    </div>
  </div>
  <div class="card-box">
    <div class="page-filters">
      <div class="filter-field">
        <span class="filter-field__label">Type of request:</span>
        <p-selectbutton
          data-cy="agent-request-type-filter"
          [options]="typeOptions"
          [ngModel]="selectedGroup"
          (onChange)="onGroupChange($event.value)"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
          size="small"
        />
      </div>
      <div class="filter-field">
        <span class="filter-field__label">Sender:</span>
        <p-selectbutton
          [options]="senderOptions"
          [ngModel]="sender"
          (onChange)="onSenderChange($event.value)"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
          size="small"
        />
      </div>
      <div class="filter-field">
        <span class="filter-field__label">Quote type:</span>
        <app-agent-request-multiselect
          placeholder="All types"
          [options]="quoteTypeOptions"
          [selected]="selectedQuoteTypes"
          (selectionChange)="onQuoteTypesChange($event)"
        />
      </div>
      <div class="filter-field">
        <span class="filter-field__label">Status:</span>
        <app-agent-request-multiselect
          placeholder="All statuses"
          [options]="statusOptions"
          [selected]="selectedStatuses"
          (selectionChange)="onStatusesChange($event)"
        />
      </div>
      <div class="filter-field">
        <span class="filter-field__label">Created at:</span>
        <app-date-picker
          [selectedRange]="createdAtRange"
          [showIcon]="true"
          (rangeChange)="onCreatedAtRangeChange($event)"
        ></app-date-picker>
      </div>
      @if (getQuoteChipLabel(); as quoteChipLabel) {
        <div class="quote-chip">
          <p-chip
            data-cy="agent-request-quote-chip"
            [label]="quoteChipLabel"
            [removable]="true"
            removeIcon="pi pi-times"
            (onRemove)="removeQuoteChip()"
          />
        </div>
      }
      @if (isClearFiltersVisible()) {
        <button
          pButton
          type="button"
          variant="text"
          class="new-filters__clear"
          (click)="clearFilters()"
        >
          <i class="pi pi-filter-slash"></i>
          Clear filters
        </button>
      }
    </div>
    <app-table
      data-cy="agent-request-table"
      [columns]="columns"
      [value]="list.items"
      [paginator]="list.totalItems > gridParams.limit"
      [loading]="loading"
      [rows]="gridParams.limit"
      [first]="gridParams.first"
      [totalRecords]="list.totalItems"
      emptyMessage="No requests found."
      (changePage)="onLoadPage($event.first / $event.rows + 1, $event.rows)"
      (sortRows)="onSortGrid($event)"
      (rowClick)="onClickRow($event.model)"
      [(selection)]="selectedRequests"
      [selectable]="true"
    >
    </app-table>
    <app-table-selection-bar
      [selectedCount]="selectedRequests.length"
      [totalCount]="list.totalItems"
      (selectAll)="selectAll()"
      (clearSelection)="clearSelection()"
    >
      @if (hasRequestedSelected()) {
        <button
          pButton
          data-cy="agent-request-batch-close"
          severity="primary"
          variant="text"
          size="small"
          (click)="closeSelected()"
        >
          <i class="pi pi-times-circle"></i> Close request
        </button>
      }
    </app-table-selection-bar>
  </div>
  <p-dialog
    header="Agent request"
    [(visible)]="detailsVisible"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="agent-request-dialog"
  >
    @if (selectedRequest) {
      <dl class="agent-request-details">
        <dt>Request type</dt>
        <dd>{{ selectedRequest.typeLabel }}</dd>
        <dt>Agent</dt>
        <dd>{{ selectedRequest.agentName }}</dd>
        <dt>Client</dt>
        <dd>{{ selectedRequest.clientName }}</dd>
        <dt>Details</dt>
        <dd>
          @if (selectedQuote) {
            <app-quote-list-row [quote]="selectedQuote" />
          }
        </dd>
        <dt>Sent</dt>
        <dd>
          {{ selectedRequest.sentAt | date: "d.MM.yy HH:mm" }}
          {{ selectedRequest.sentByName }}
        </dd>
        <dt>Quote</dt>
        <dd>
          @if (selectedRequest.getQuoteUrl(); as quoteUrl) {
            <a class="text-link" [href]="quoteUrl" target="_blank">{{
              selectedRequest.quoteId
            }}</a>
          }
        </dd>
      </dl>
      <div
        class="agent-request-email"
        [innerHTML]="selectedRequest.details | safeHtml"
      ></div>
    }
  </p-dialog>
</div>
